import UiButton from "@/UI-Components/Buttons/UiButton";
import UiImage from "@/UI-Components/Image/UiImage";
import { datetimeUtility } from "@/utlities/dateTime.utility";
import { Menu, MenuButton, MenuItems } from "@headlessui/react";
import { PowerIcon } from "lucide-react";
import useAuthCard from "./hooks/useAuthCard";
import { stringUtility } from "@/utlities/string.utlity";

const AuthUserCard = () => {
  const {
    services: { getSingleUserService },
    mutations: { logOutMutations },
    function: { handleLogOut },
  } = useAuthCard();

  const userData = getSingleUserService?.data?.data;

  return (
    <Menu as="div" className="w-full">
      <MenuButton className="w-full z-[60] outline-none border border-lightGray/30 bg-lightGray/30 px-2 py-1 rounded">
        <section className={`flex items-center gap-1 `}>
          <UiImage
            src={""}
            className={`ring-1 ring-lightGray rounded-full object-cover min-w-10 `}
            containerClass="w-10 rounded-full bg-extraLightGray"
          />
          <section className="flex-col   text-left leading-4 px-2">
            <p className="text-xs font-semibold ">{userData?.name}</p>
            <p className="text-xs font-medium text-body">
              {stringUtility.addEllipsisAtEnd(String(userData?.email), 20)}
            </p>
          </section>
        </section>
      </MenuButton>

      <MenuItems
        transition
        anchor="bottom"
        className="w-56 absolute bg-white border  border-extraLightGray/80 rounded shadow-2xl shadow-body/20  pt-2 mt-2
          transition ease-in-out data-[closed]:opacity-0 data-[enter]:duration-300 data-[enter]:data-[closed]:-translate-x-2 data-[leave]:duration-100 data-[leave]:-translate-x-1 z-10  right-12 focus-visible:ring-2 focus-visible:ring-lightGray/30  outline-none"
      >
        <section className="flex flex-col text-left leading-4 px-2 ">
          <p className="text-sm font-semibold">{userData?.name}</p>
          <p className="text-xs font-medium text-body">{userData?.email}</p>
        </section>
        <div className="text-xs font-semibold mt-2 flex items-center pb-2 px-2 border-b border-extraLightGray/60 ">
          <p className="text-darkGray ">Last login: </p>
          <p className="text-heading">
            {datetimeUtility.formatJsDate({
              value: String(userData?.last_login),
              format: "dd-MM-yyyy hh:mm:ss",
            })}
          </p>
        </div>

        <section className="px-2 pb-2">
          <UiButton
            text="Logout"
            buttonType="tertiary"
            className="font-semibold rounded w-full h-7
           bg-error/10 text-error text-left flex-row-reverse ring-1 ring-error/30"
            icon={<PowerIcon className="size-4 text-inherit" />}
            onClick={handleLogOut}
            isLoading={logOutMutations.isPaused}
          />
        </section>
      </MenuItems>
    </Menu>
  );
};

export default AuthUserCard;
